<div
  *ngIf="discoverTilesOptions"
  [reactComponent]="DiscoverTilesComponent$"
  [props]="{
    tiles: tiles,
    options: discoverTilesOptions,
    businessVertical: 'food',
    onTileToggle: onTileToggleCallBack
  }"
></div>
